// extracted by mini-css-extract-plugin
export default {"image":"OptionImage_image__hIDr4"};